import { mandatory } from '../../../storeFromRequestParamsValidation';
import { createPath } from './createPath.utils';

export const createMainCategory = (editionEndpoint: any) => (mainCategory: any) => {
  return {
    displayName: mandatory(mainCategory.displayName, ''),
    link: mandatory(mainCategory.path, '', createPath(editionEndpoint)),
    isActive: mandatory(mainCategory.isActive, false),
  };
};

export const createBreadCrumbs = (editionEndpoint: string, homeTranslation: string) => (mainCategory: any) => {
  return {
    homeDisplayName: homeTranslation,
    homeLink: createPath(editionEndpoint)(''),
    categoryDisplayName: mandatory(mainCategory.displayName, ''),
    categoryLink: mandatory(mainCategory.path, '', createPath(editionEndpoint)),
    isActive: mandatory(mainCategory.isActive, false),
  };
};

export const createAmpMainCategory = (editionEndpoint: any) => (mainCategory: any) => {
  return {
    displayName: mandatory(mainCategory.displayName, ''),
    link: mandatory(mainCategory.path, '', createPath(editionEndpoint)),
    isActive: mandatory(mainCategory.isActive, false),
    slug: mandatory(mainCategory.slug, ''),
  };
};
